import { combineReducers } from 'redux';
import detailsReducer from './details';

const articleReducer = combineReducers({
  details: detailsReducer,
})

export default articleReducer;
